import { useContext, useMemo } from 'react';
import { ExperimentsContext } from '@agria/theme/src/context/ExperimentsContext';
import { useSiteMetadata } from '@agria/theme/src/hooks/useSiteMetadata';

export const useDeclarationAfterReview = () => {
  const { experiments } = useContext(ExperimentsContext);
  const { declarationAfterReview } = useSiteMetadata();

  return useMemo(
    () => experiments?.AGRIA138 === 'variation' || !!declarationAfterReview,
    [declarationAfterReview, experiments?.AGRIA138],
  );
};
